"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

var _icon = _interopRequireDefault(require("../icon"));

// Notification
// ============
var getIcon = function getIcon(type) {
  return type === 'success' ? 'tick' : 'alert';
};

var Notification = function Notification(_ref) {
  var type = _ref.type,
      message = _ref.message,
      onClickDismiss = _ref.onClickDismiss,
      className = _ref.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].Notification, _index["default"][type], className)
  }, _react["default"].createElement("header", {
    className: _index["default"].header
  }, _react["default"].createElement(_icon["default"], {
    size: "large",
    className: (0, _classnames["default"])(_index["default"].icon, _index["default"][type]),
    type: getIcon(type)
  }), _react["default"].createElement("span", {
    className: _index["default"].message
  }, message), onClickDismiss && _react["default"].createElement("button", {
    "aria-label": "Dismiss",
    onClick: onClickDismiss,
    className: _index["default"].dismiss
  }, _react["default"].createElement("svg", {
    className: _index["default"][type],
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, _react["default"].createElement("path", {
    fill: "none",
    d: "M13 13L1 1m12 0L1 13"
  })))));
};

Notification.propTypes = {
  type: _propTypes["default"].oneOf(['success', 'info', 'failure']),
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  onClickDismiss: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var _default = Notification;
exports["default"] = _default;